import useHydrated from '@hooks/useHydrated';

function LumeraPersistGate({ children, fallback }) {
  const hydrated = useHydrated();

  return hydrated ? children : fallback || null;
}

export default (props, railsContext) => (
  <LumeraPersistGate {...{ ...props, railsContext }} />
);
